/* istanbul ignore file */

import('./index.scss');
import('./theme.scss');
import('./Apps');

export {};
